"use client"

import { useEffect, useState } from "react"
import {
    Typography,
    Button,
    IconButton,
    Box,
    Container,
    TextField,
    InputAdornment,
    Chip,
    useTheme,
    useMediaQuery,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Divider,
    Grid,
    Card,
    CardMedia,
    CardContent,
    InputLabel,
    Paper,
    InputBase,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stepper,
    Step,
    StepLabel,
    ImageList,
    ImageListItem,
    ImageListItemBar,
} from "@mui/material"
import LocalParkingIcon from "@mui/icons-material/LocalParking"
import EmailIcon from "@mui/icons-material/Email"
import { Link } from '@mui/material';
import { Stack } from "@mui/material";

import {
    Search as SearchIcon,
    Close as CloseIcon,
    Facebook,
    Twitter,
    Instagram,
    LinkedIn,
    SquareFoot,
    VisibilityOff,
    Visibility,
    Send,
} from "@mui/icons-material"
import DashboardIcon from "@mui/icons-material/Dashboard"
import SecurityIcon from "@mui/icons-material/Security"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"

import { Images } from "../../../assets/images"
import Loader from "../../../components/Loader"

import Colors from "../../../assets/styles"
import { useForm } from "react-hook-form"
import SimpleDialog from "../../../components/Dialog"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import AuthServices from "../../../api/AuthServices/auth.index"
import { ErrorToaster, SuccessToaster } from "../../../components/Toaster"
import FileServices from "../../../api/FileServices/file.index"
import { useAuth } from "../../../context"
import PropertyServices from "../../../api/PropertyServices/property.index"
import Header from "../Header"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import { trackGtmEvent } from "../../../utils/gtm"

const AboutUs = () => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [selectedType, setSelectedType] = useState("")
    const [activeStep, setActiveStep] = useState(0)

    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [openBookDialog, setOpenBookDialog] = useState(false)
    const [properties, setProperties] = useState([])
    const navigate = useNavigate()
    const [propertyData, setPropertyData] = useState([])
    const [maxMin, setMaxMin] = useState(null)
    const [bookingLoading, setBookingLoading] = useState(false)
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [openBookRegisterDialog, setOpenBookRegisterDialog] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [images, setImages] = useState(null)
    const [docLoading, setDocLoading] = useState(false)
    const [imgLoading, setImgLoading] = useState(false)
    const [loader, setLoader] = useState(false)
    const [preview, setPreview] = useState(null)
    const [docPreview, setDocPreview] = useState(null)
    const [document, setDocument] = useState(null)

    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const itemData = [
        {
            img: Images.newItemData1,
            title: "GFS",
            author: "@bkristastucchio",
        },
        {
            img: Images.newItemData2,
            title: "Mex",
            author: "@rollelflex_graphy726",
        },
        {
            img: Images.newItemData3,
            title: "Refine",
            author: "@helloimnik",
        },
        {
            img: Images.newItemData4,
            title: "Wanta Shipping",
            author: "@nolanissac",
        },
    ]

    const steps = ["Agent Information", "Booking Details"]

    const handleNext = async () => {
        const isValid = await trigger(["name", "phone", "address", "rearaid", "email", "password"])

        if (isValid) {
            clearErrors()
            setActiveStep((prev) => prev + 1)
        }
    }

    const handleBack = () => {
        clearErrors()
        setActiveStep((prev) => prev - 1)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const [filters, setFilters] = useState({
        propertyType: "",
        location: "",
        bedrooms: "",
        priceRange: [0, 10000000],
    })
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    })

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
    }

    const handleSubmit2 = (e) => {
        e.preventDefault()
        console.log("Form submitted:", formData)
        // Handle form submission here
    }
    const { WebUserLogin, webUser } = useAuth()
    const timeSlots = ["1-2", "2-3", "3-4", "4-5", "5-6", "6-7", "7-8", "8-9", "9-10", "10-11", "11-12", "12-1"]
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        reset,
        trigger,
        clearErrors,
        formState: { errors },
    } = useForm()

    const selectedTime = watch("timeSlot")

    const handleMobileMenuToggle = () => {
        setMobileMenuOpen(!mobileMenuOpen)
    }

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value)
    }

    const handleSearch = () => {
        const params = new URLSearchParams()

        if (filters.location) {
            params.append("location", filters.location)
        }

        if (filters.propertyType) {
            params.append("type", filters.propertyType)
        }

        if (selectedType) {
            params.append("purpose", selectedType.toLowerCase())
        }

        navigate(`/property-list?${params.toString()}`)
    }

    const mobileMenu = (
        <Drawer
            anchor="left"
            open={mobileMenuOpen}
            onClose={handleMobileMenuToggle}
            sx={{
                "& .MuiDrawer-paper": {
                    width: 280,
                    backgroundColor: "#fff",
                },
            }}
        >
            <Box
                sx={{
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h6" sx={{ color: "#4a5568" }}>
                    Menu
                </Typography>
                <IconButton onClick={handleMobileMenuToggle}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Divider />
            <List>
                <ListItem button>
                    <ListItemText primary="Sign Up / Sign In" />
                </ListItem>
            </List>
        </Drawer>
    )

    const features = [
        {
            icon: <DashboardIcon fontSize="large" color="primary" />,
            title: "Smart Dashboard",
            description: "Manage everything in one place with real-time updates.",
        },
        {
            icon: <SecurityIcon fontSize="large" color="primary" />,
            title: "Secure Platform",
            description: "Your data is encrypted and protected at every step.",
        },
        {
            icon: <SupportAgentIcon fontSize="large" color="primary" />,
            title: "24/7 Support",
            description: "Get round-the-clock assistance from our expert team.",
        },
    ]
    const cardData = [
        {
            title: "Office Furniture",
            description:
                "With our global network of furniture suppliers and in-house joinery fit out, spanning 20,000 sqft, we offer our clients a complete furniture and ergonomic solutions, enhancing your workspace's comfort.",
            image: Images.expertcard1,
        },
        {
            title: "Design & Build",
            description:
                "As a top interior design and build company in the UAE, we specialise in creating workspaces that reflect your identity. Our expert in-house team ensures your design aligns with your values.",
            image: Images.expertcard2,
        },
        {
            title: "Office Fit-Out",
            description:
                "Let our experienced team of fit-out contractors manage your office fit-out, and we'll create the perfect, ergonomic environment that reflects your unique brand identity but also engages your employees.",
            image: Images.expertcard3,
        },
        {
            title: "Office Refurbishment",
            description:
                "Refurbishing your office is an excellent chance to breathe new life into your workspace. This process allows you to reinvent and revitalize your work environment, enhancing both aesthetics and functionality.",
            image: Images.expertcard4,
        },
    ]

    useEffect(() => {
        // Remove property fetching for About page
    }, [])

    const handlePropertyClick = (propertyName) => {
        console.log(`Clicked on ${propertyName}`)
    }

    const socialLinks = [
        { icon: <Facebook />, name: "Facebook", url: "#" },
        { icon: <Twitter />, name: "Twitter", url: "#" },
        { icon: <Instagram />, name: "Instagram", url: "#" },
        { icon: <LinkedIn />, name: "LinkedIn", url: "#" },
    ]

    const developers = [
        { name: "DAMAC", logo: Images.hero1 },
        { name: "EMAAR", logo: Images.hero2 },
        { name: "MERAAS", logo: Images.hero3 },
        { name: "SOBHA", logo: Images.hero4 },
        { name: "NAKHEEL", logo: Images.hero5 },
        { name: "Sobha", logo: Images.hero6 },
        { name: "Sobha", logo: Images.hero7 },
        { name: "Sobha", logo: Images.hero8 },
    ]
    const formatPrice = (price) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "AED",
            minimumFractionDigits: 0,
        }).format(price)
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Header />

            {/* Hero */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "100vh",
                    overflow: "hidden",
                }}
            >
                {/* Background Image */}
                <Box
                    component="img"
                    src={Images.RRBanner}
                    alt="Ready offices background"
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        zIndex: 0,
                    }}
                />

                {/* Overlay */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 1,
                    }}
                />

                {/* Centered Content */}
                <Container
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        transform: "translateY(-30px)",
                    }}
                >
                    <Box
                        sx={{
                            color: "white",
                            px: { xs: 2, md: 0 },
                            maxWidth: "800px",
                        }}
                    >
                        <Typography
                            variant="h2"
                            sx={{
                                mb: 2,
                                fontSize: { md: "25px", sm: "25px", xs: "25px" },
                            }}
                        >
                            <span
                                style={{
                                    lineHeight: 1.1,
                                    fontFamily: "'Gotham-Light', sans-serif",
                                    textTransform: "uppercase",
                                    fontWeight: 300,
                                    color: "rgba(255, 255, 255, 0.7)",
                                    letterSpacing: 8.5,
                                    fontSize: "45px",
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "45px",
                                    }}
                                    className="about-text"
                                >
                                    About
                                </span>
                            </span>
                            <br />
                            <span
                                style={{
                                    fontFamily: "'Gotham-Light', serif",
                                    textTransform: "uppercase",
                                    fontSize: "70px",
                                    letterSpacing: 8.3,
                                }}
                                className="rr-text"
                            >
                                RR Properties
                            </span>

                            <style>
                                {`
      @media (max-width: 600px) {
        .about-text {
          font-size: 42px !important;
        }
        .rr-text {
          font-size: 42px !important;
        }
      }
    `}
                            </style>
                        </Typography>


                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 400,
                                opacity: 0.95,
                                fontFamily: "'Gotham-Book',sans-serif",
                                textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                                maxWidth: 680,
                                mx: "auto",
                            }}
                        >
                            Transforming Dubai's commercial real estate landscape with innovation, integrity, and exceptional results.
                        </Typography>
                    </Box>
                </Container>
            </Box>

            {/* Our Story Section */}
            <Box sx={{ py: { xs: 2, md: 6 }, background: "linear-gradient(to bottom, #112d55 0%, #081434 100%)" }}>
                <Container sx={{ maxWidth: "1300px !important" }}>
                    <Box sx={{ textAlign: "center", mb: { xs: 4, md: 8 } }}>
                        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                            <img
                                src={Images.RRAboutUs}
                                alt="Centered Image"
                                style={{ maxWidth: "100%", height: "auto" }}
                            />
                        </Box>

                        <Typography
                            variant="p"
                            sx={{
                                fontSize: { xs: "1rem", sm: "1.1rem", md: "1.75rem" },
                                color: "#c2a261",
                                fontWeight: 500,
                                textTransform: "uppercase",
                                maxWidth: "750px",
                                fontFamily: "'Copperplate-Gothic-32-BC', sans-serif",
                                mx: "auto",
                            }}
                        >
                            Redefining commercial real estate in Dubai
                        </Typography>
                        <br /><br />

                        <Box sx={{ maxWidth: "750px", mx: "auto", mb: 3 }}>
                            <Typography
                                variant="p"
                                sx={{
                                    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.22rem" },
                                    color: "white",
                                    fontWeight: 400,
                                    maxWidth: "750px",
                                    fontFamily: "'Gotham-Light', sans-serif",
                                    mx: "auto",
                                }}
                            >
                                RR Properties was founded with a vision to transform Dubai's commercial
                                real estate landscape. What began as a bold investment strategy has grown
                                into a portfolio that consistently delivers exceptional returns. We're setting
                                new benchmarks across prime business districts, such as JLT,
                                Business Bay, DIFC, and Dubai South.
                            </Typography>
                            <br /> <br />
                        </Box>

                        <Box sx={{ maxWidth: "750px", mx: "auto", mb: 3 }}>
                            <Typography
                                variant="p"
                                sx={{
                                    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.75rem" },
                                    color: "#c2a261",
                                    fontWeight: 500,
                                    textTransform: "uppercase",
                                    maxWidth: "750px",
                                    fontFamily: "'Copperplate-Gothic-32-BC', sans-serif",
                                    mx: "auto",
                                }}
                            >
                                Innovation, Integrity, Excellence, & Growth
                            </Typography>
                            <br /> <br />
                            <Typography
                                variant="p"
                                sx={{
                                    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.22rem" },
                                    color: "white",
                                    fontWeight: 400,
                                    maxWidth: "750px",
                                    fontFamily: "'Gotham-Light', sans-serif",
                                    mx: "auto",
                                }}
                            >
                                These define RR Properties—spotting opportunities, building trust, ensuring quality, and creating lasting value. These values set us apart by delivering premium management and trusted partnerships that drive success.
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>

            {/* Simple Image Section */}
            <Box sx={{ position: "relative", width: "100%", background: "#112d55" }}>
                <Box
                    component="img"
                    src={Images.SimplePimage}
                    alt="RR Property"
                    sx={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                        background: "#112d55",
                    }}
                />
            </Box>

            {/* The RR Properties Advantage Section */}
            <Box
                sx={{
                    position: "relative",
                    background: "linear-gradient(to bottom, #112d55 30%, #081434 80%)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    py: { xs: 6, md: 2 },
                    minHeight: { xs: 320, md: 480 },
                }}
            >
                <Container sx={{ position: "relative", zIndex: 1, maxWidth: "1300px !important" }}>
                    <Box sx={{ py: { xs: 2, md: 6 }, textAlign: "center", mb: { xs: 4, md: 2 } }}>
                        <Typography
                            variant="h2"
                            sx={{
                                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                                fontWeight: 500,
                                color: Colors.primary,
                                fontFamily: "'Copperplate-Gothic-32-BC',sans-serif",
                            }}
                        >
                            The RR Properties Advantage
                        </Typography>
                    </Box>

                    {/* 5 Columns Layout with Icons and Text */}
                    <Box sx={{ mx: "auto", mt: 4, mb: 8 }}>
                        <Grid container spacing={1} justifyContent="space-between">
                            <Grid item xs={12} sm={6} md={2} sx={{ textAlign: "center" }}>
                                <Box sx={{ mb: 2 }}>
                                    <img src={Images.HighRentalIcon} alt="High Rental" style={{ width: "50px", height: "50px" }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: { xs: "14px", sm: "14px", md: "15px" }, color: "white", fontWeight: 300, fontFamily: "'Gotham-Light',sans-serif", textTransform: "uppercase" }}>
                                    High rental yields across prime districts
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} sx={{ textAlign: "center" }}>
                                <Box sx={{ mb: 2 }}>
                                    <img src={Images.InvestorFriendlyIcon} alt="Investor Friendly Long-term Contracts Dubai" style={{ width: "50px", height: "50px" }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: { xs: "14px", sm: "14px", md: "15px" }, color: "white", fontWeight: 300, fontFamily: "'Gotham-Light',sans-serif", textTransform: "uppercase" }}>
                                    Investor-friendly, long-term contracts
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} sx={{ textAlign: "center" }}>
                                <Box sx={{ mb: 2 }}>
                                    <img src={Images.ReliableCorporateIcon} alt="Reliable Corporate Tenants Dubai" style={{ width: "50px", height: "50px" }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: { xs: "14px", sm: "14px", md: "15px" }, color: "white", fontWeight: 300, fontFamily: "'Gotham-Light',sans-serif", textTransform: "uppercase" }}>
                                    Reliable corporate tenants
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} sx={{ textAlign: "center" }}>
                                <Box sx={{ mb: 2 }}>
                                    <img src={Images.StableIcon} alt="Stable Real Estate Income Dubai" style={{ width: "50px", height: "50px" }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: { xs: "14px", sm: "14px", md: "15px" }, color: "white", fontWeight: 300, fontFamily: "'Gotham-Light',sans-serif", textTransform: "uppercase" }}>
                                    Stable income with lower vacancy risks
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={2} sx={{ textAlign: "center" }}>
                                <Box sx={{ mb: 2 }}>
                                    <img src={Images.StrategicInvensionIcon} alt="Strategic Fit-Out Commercial Real Estate" style={{ width: "50px", height: "50px" }} />
                                </Box>
                                <Typography variant="body1" sx={{ fontSize: { xs: "14px", sm: "14px", md: "15px" }, color: "white", fontWeight: 300, fontFamily: "'Gotham-Light',sans-serif", textTransform: "uppercase" }}>
                                    Added value through strategic fit-out
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ maxWidth: "800px", textAlign: "center", mx: "auto", mb: 3 }}>
                        <Typography
                            variant="p"
                            sx={{
                                fontSize: { xs: "1rem", sm: "1.1rem", md: "1.32rem" },
                                color: "white",
                                fontWeight: 400,
                                fontFamily: "'Gotham-Light', sans-serif",
                                mx: "auto",
                            }}
                        >
                            Guided by transparency, innovation, and integrity, RR Properties LLC is dedicated to helping clients capitalise on Dubai's ever-growing real estate potential - a global hub of economic growth, stability, and opportunity.
                        </Typography>
                    </Box>

                    <Box sx={{ py: { xs: 2, md: 1 }, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={Images.RRGoldBan} alt="RR Properties Dubai Portfolio Banner" style={{ maxWidth: "100%", height: "auto", py: { xs: 2, md: 3 } }} />
                    </Box>

                    {/* Our Services Section */}
                    <Box sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}>
                        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                            <img
                                src={Images.RROurServices}
                                alt="RR Properties Real Estate Services Dubai"
                                style={{ maxWidth: "100%", height: "auto" }}
                            />
                        </Box>

                        <Box sx={{ maxWidth: "750px", mx: "auto" }}>
                            <Typography
                                variant="p"
                                sx={{
                                    fontSize: { xs: "1rem", sm: "1.1rem", md: "1.22rem" },
                                    color: "white",
                                    fontWeight: 400,
                                    maxWidth: "750px",
                                    fontFamily: "'Gotham-Light', sans-serif",
                                    mx: "auto",
                                }}
                            >
                                At RR Properties, we go beyond traditional real estate investment. Our end-to-end approach ensures that every asset is transformed into a high-performing property that delivers exceptional results.
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ py: { xs: 6, md: 3 } }}>
                        <Container sx={{ maxWidth: "1300px !important" }}>
                            <Grid container spacing={{ xs: 3, md: 4 }} sx={{ bgcolor: "transparent", backgroundImage: "none" }}>
                                {[
                                    {
                                        title: "Property Acquisition",
                                        description: "Identifying undervalued opportunities in Dubai's dynamic real estate market with strategic location analysis and market intelligence.",
                                        icon: Images.Service1,
                                    },
                                    {
                                        title: "Renovation & Repositioning",
                                        description: "Transforming assets into premium spaces through our in-house design and build expertise, maximizing property value and appeal.",
                                        icon: Images.Service2,
                                    },
                                    {
                                        title: "Leasing & Sales",
                                        description: "Delivering top-value returns through strategic marketing, tenant placement, and sales optimization for maximum ROI.",
                                        icon: Images.Service3,
                                    },
                                    {
                                        title: "Portfolio Management",
                                        description: "Long-term growth strategies for investors with comprehensive property management and performance monitoring.",
                                        icon: Images.Service4,
                                    },
                                ].map((service, index) => (
                                    <Grid item xs={12} sm={6} md={3} mb={8} key={index}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 4,
                                                textAlign: "center",
                                                borderRadius: 3,
                                                bgcolor: "transparent",
                                                backgroundImage: "none",
                                                height: 300,
                                                border: "1px solid #b6b8bb",
                                                transition: "all 0.3s ease-in-out",
                                                "&:hover": {
                                                    transform: "translateY(-8px)",
                                                    boxShadow: "0 12px 40px rgba(0,0,0,0.1)",
                                                    borderColor: Colors.primary,
                                                },
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={service.icon}
                                                alt={`${service.title} icon`}
                                                sx={{
                                                    width: 72,
                                                    height: 72,
                                                    objectFit: "contain",
                                                    display: "block",
                                                    mx: "auto",
                                                    mb: 2,
                                                }}
                                            />

                                            <Typography
                                                variant="h5"
                                                sx={{ whiteSpace: "pre-line", fontWeight: 400, textTransform: "uppercase", color: Colors.primary, mb: 1.5, fontFamily: "'Gotham-Light',sans-serif", fontSize: { xs: "1rem", sm: "1.1rem", md: "1.3rem" } }}
                                            >
                                                {service.title}
                                            </Typography>

                                            <Typography sx={{ color: "white", lineHeight: 1.5, fontFamily: "'Gotham-Book',Sans-serif", fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" } }}>
                                                {service.description}
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Container>
                    </Box>
                </Container>
            </Box>

            {/* Legal & Contract Management Section */}
            <Box sx={{ position: "relative", background: "#e5e0da" }}>
                <Box sx={{ width: '100%', pt: { xs: 4, md: 6 }, pb: { xs: 6, md: 6 } }}>
                    <Container sx={{ maxWidth: '1300px', margin: '0 auto' }}>
                        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <Grid item xs={12} sm={4} sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <Box sx={{ backgroundColor: 'transparent', padding: '20px', height: '100%' }}>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: "bold",
                                            fontSize: { xs: "16px", sm: "18px", md: "35px" },
                                            lineHeight: "1.1",
                                            color: Colors.darkblue,
                                            fontFamily: "'Copperplate-Gothic-32-BC',sans-serif",
                                        }}
                                    >
                                        Legal & Contract Management
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: '#000', fontFamily: "'Gotham-Book',sans-serif" }}>
                                        At RR Properties, we don't just deliver high-yield commercial spaces—we also safeguard your investments through comprehensive legal and contractual management.
                                    </Typography><br />
                                    <Button
                                        size="medium"
                                        sx={{
                                            backgroundColor: Colors.primary,
                                            color: "white",
                                            fontSize: "16px",
                                            borderRadius: "0",
                                            fontWeight: 400,
                                            px: 3,
                                            textTransform: "none",
                                            "&:hover": {
                                                backgroundColor: Colors.primary,
                                                opacity: 0.8,
                                            },
                                        }}
                                    >
                                        Let's Talk
                                    </Button>
                                </Box>
                            </Grid>

                            {[
                                {
                                    icon: Images.NewIcon1,
                                    title: "Drafting & Reviewing Contracts",
                                    description: "From tenancy agreements to sales & purchase contracts, we structure every clause to protect your interests."
                                },
                                {
                                    icon: Images.NewIcon2,
                                    title: "Entry & Exit Strategies",
                                    description: "We design flexible entry and exit clauses that give you smooth onboarding as a tenant or investor, and clearly defined exit pathways to minimize risk."
                                },
                                {
                                    icon: Images.NewIcon3,
                                    title: "Regulatory Compliance",
                                    description: "All contracts are aligned with Dubai Land Department regulations and free-zone requirements, ensuring your transactions remain secure and legally sound."
                                },
                                {
                                    icon: Images.NewIcon4,
                                    title: "Risk Mitigation",
                                    description: "We anticipate and address potential legal challenges—covering areas like VAT, subleasing rights, brokerage fees, and clearance procedures—so you're always protected."
                                },
                                {
                                    icon: Images.NewIcon5,
                                    title: "Negotiation Support",
                                    description: "Our team represents your interests in negotiations, ensuring favorable terms while maintaining long-term stability with counterparties."
                                }
                            ].map((item, index) => (
                                <Grid item xs={12} sm={4} key={index} sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <Box sx={{ backgroundColor: 'white', borderRadius: '0px', padding: '20px', border: '1px solid #ddd', height: '100%' }}>
                                        <Box sx={{ mb: 1, textAlign: 'left' }}>
                                            <img src={item.icon} alt={item.title} style={{ width: '50px', height: '50px', marginBottom: '5px' }} />
                                        </Box>
                                        <Typography variant="h6" sx={{ fontWeight: 600, color: Colors.darkblue, textAlign: 'left', fontFamily: "'Gotham-Book',sans-serif" }}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#555', textAlign: 'left' }}>
                                            {item.description}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>
            </Box>



            {/* Footer */}
            <Box component="footer" sx={{ backgroundColor: "#081534", color: "white", py: 6 }}>
                <Container maxWidth="xl">
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography variant="body2" sx={{ color: Colors.white, fontFamily: "'Gotham-Book',sans-serif", mr: 2, display: { sm: "block" } }}>
                                    Contact Us at :{" "}
                                    <Box
                                        component="a"
                                        href="mailto:info@prroperties.ae"
                                        onClick={() =>
                                            trackGtmEvent("contact", {
                                                method: "email",
                                                email: "info@prroperties.ae",
                                            })
                                        }
                                        sx={{
                                            color: Colors.white,
                                            textDecoration: "underline",
                                            textUnderlineOffset: "3px",
                                            transition: "opacity 0.2s ease-in-out",
                                            "&:hover": {
                                                opacity: 0.8,
                                            },
                                        }}
                                    >
                                        info@prroperties.ae
                                    </Box>
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Box onClick={() => navigate("/")} sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}>
                                    <Box
                                        component="img"
                                        src={Images.RRLogo}
                                        alt="RR Property Expert"
                                        sx={{ width: { md: "100%", xs: "100%" }, height: { md: "60px", xs: "60px" } }}
                                    />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: { xs: "center", md: "right" }, display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "center", md: "flex-end" }, justifyContent: { md: "flex-end" }, gap: { xs: 1, sm: 2 } }}>
                                <Typography variant="body2" sx={{ color: Colors.white, fontFamily: "'Gotham-Book',sans-serif", fontSize: "0.875rem" }}>
                                    © {moment().format("YYYY")} All rights reserved.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {mobileMenu}
        </Box>
    )
}

export default AboutUs